var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoiceSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "invoice_selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-/-icons-/-factures-(green)",
    transform: "translate(-1.000000, -1.000000)",
    fill: "#37DC58",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,20.999962 L4,20.999962 C3.20435,20.999962 2.44129,20.683962 1.87868,20.121362 C1.316071,19.558662 1,18.795662 1,17.999962 L1,2 C1,1.734782 1.105357,1.480432 1.292893,1.292893 C1.48043,1.105356 1.73478,1 2,1 L16,1 C16.2652,1 16.5196,1.105356 16.7071,1.292893 C16.8946,1.480432 17,1.734782 17,2 L17,13.999962 L21,13.999962 L21,17.999962 C21,18.795662 20.6839,19.558662 20.1213,20.121362 C19.5587,20.683962 18.7956,20.999962 18,20.999962 Z M17,15.999962 L17,17.999962 C17,18.265262 17.1054,18.519562 17.2929,18.707062 C17.4804,18.894662 17.7348,18.999962 18,18.999962 C18.2652,18.999962 18.5196,18.894662 18.7071,18.707062 C18.8946,18.519562 19,18.265262 19,17.999962 L19,15.999962 L17,15.999962 Z M5,6.000002 L5,8.000002 L13,8.000002 L13,6.000002 L5,6.000002 Z M5,10.000002 L5,11.999962 L13,11.999962 L13,10.000002 L5,10.000002 Z M5,13.999962 L5,15.999962 L10,15.999962 L10,13.999962 L5,13.999962 Z",
    id: "invoice_selected"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceSelected);
export default __webpack_public_path__ + "static/media/invoice_selected.ff80cde77e7b4f34a8b1b649b5a3f269.svg";
export { ForwardRef as ReactComponent };